'AdjustmentSlip'.output()
'ADJUSTMENT SLIP'.title()
'Adjustment'.datatype()

'Header'.section({pageHeading: true})
'adjustmentNumber'.field()
'date'.field()
'location'.field()
'product'.field()
'notes'.field()
'quantityOnHand'.field()
'quantity'.field()
'taxPct'.field()
'unitCostIncTax'.field()
'lineCostIncTax'.field()
'lineTax'.field()
